export const NAV_LINKS = [
  { label: "Home", to: "/" },
  { label: "About", to: "/about" },
  { label: "Services", to: "/services" },
  { label: "Projects", to: "/projects" },
  { label: "Calculator", to: "/calculator" },
  { label: "AI Designer", navLabel: "AI Design", to: "/ai-designer" },
  { label: "Blog", to: "/blog" },
  { label: "Contact", to: "/contact" },
];

export const CONTACT = {
  email: "Intr.kalpavriksha@gmail.com",
  phone: "9063222753",
  phoneDisplay: "+91 90632 22753",
  telHref: "tel:+919063222753",
  mailHref: "mailto:Intr.kalpavriksha@gmail.com",
  whatsappHref:
    "https://wa.me/919063222753?text=" +
    encodeURIComponent("Hi Kalpavriksha, I'd like to enquire about your project."),
  address:
    "2nd Floor, Above CLASSIC Online Centre, Plot No. 308, Goldcrest School Road, TNGO's Colony, Gachibowli, Hyderabad, Telangana 500046, India",
  hours: "Mon – Sat · 9:30 AM – 7:00 PM",
  instagram: "https://www.instagram.com/kalpavriksha.world?igsh=Z2xwa2ZwaXFyeXdv",
};

export const IMG = {
  hero: "https://images.pexels.com/photos/20418771/pexels-photo-20418771.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=1400",
  architecture: "https://images.unsplash.com/photo-1479839672679-a46483c0e7c8?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  living1: "https://images.unsplash.com/photo-1724582586529-62622e50c0b3?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  living2: "https://images.unsplash.com/photo-1720247520862-7e4b14176fa8?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  living3: "https://images.unsplash.com/photo-1720247520881-672bc136da8a?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  living4: "https://images.unsplash.com/photo-1646987916641-1f3c8992daa2?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  bed1: "https://images.unsplash.com/photo-1750420556288-d0e32a6f517b?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  bed2: "https://images.unsplash.com/photo-1720420021124-4e18564e070f?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  kitchen1: "https://images.unsplash.com/photo-1663811396777-05505d999151?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  kitchen2: "https://images.unsplash.com/photo-1663811396760-b6c84fa45ee9?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
};

export const PACKAGES = [
  { name: "Basic", rate: 1399, oldRate: 1500, tag: "Smart Essentials", features: ["CenturyPly / Greenply", "Ebco hardware", "Laminate finishes", "Standard lighting"] },
  { name: "Modern", rate: 1899, oldRate: 2000, tag: "Elevated Living", features: ["Greenply / HDHMR", "Godrej hardware", "Acrylic & PU finishes", "Designer lighting"] },
  { name: "Premium", rate: 2499, oldRate: 2800, tag: "Refined Luxury", features: ["HDHMR core", "Hettich hardware", "Veneer & PU", "False ceiling included"] },
  { name: "Luxury", rate: 3799, oldRate: 4000, tag: "Signature Bespoke", features: ["BWP 710 Grade", "Hafele hardware", "Imported finishes", "Full home automation"] },
];

export const PROJECTS = [
  { title: "Aparna Zicon", cat: "Apartment", img: IMG.living1, span: "lg:col-span-8" },
  { title: "Ira Miracle", cat: "Apartment", img: IMG.living4, span: "lg:col-span-4" },
  { title: "Praneeth Pranav Jaithra", cat: "Apartment", img: IMG.bed1, span: "lg:col-span-4" },
  { title: "ADR & Makuta My Space 2", cat: "Apartment", img: IMG.kitchen1, span: "lg:col-span-4" },
  { title: "Urban on Cloud", cat: "Apartment", img: IMG.living2, span: "lg:col-span-8" },
];

export const STATS = [
  { value: "250+", label: "Projects Delivered" },
  { value: "6+", label: "Years of Crafting" },
  { value: "98%", label: "Client Referrals" },
  { value: "40+", label: "Artisans & Experts" },
];

export { SERVICES } from "./serviceOfferings";
